import { CrudStoreItemOnboarding } from 'legacy/lut/classes/models/onboarding/CrudStoreItemOnboarding'
import { IUploadHistory } from 'legacy/lut/classes/models/onboarding/IUploadHistory'
import { getErrorResponse } from 'legacy/lut/functions'

import { IPaging, Logic, Operator } from 'core-components/types'
import { IDataProviderFilter, IDataProviderSort } from 'core-components/types'
import WebSocketStore from 'core/classes/services/WebSocketStore'
import { CrudStore } from 'core/types/crudStore'
import { OnboardingUploadType } from 'onboarding/classes/models/onboardingUpload'

export enum EUploadHistoryCrudKey {
  uploadHistoryFilteredByType = 'uploadHistoryFilteredByType',
}

class OnboardingUploadHistoryApi {
  public readonly FORM_ID = 1161
  public readonly FORM_CODE = 'onboardinguploads-1161'

  public async deleteRow(id: number) {
    const wsClient = WebSocketStore.get('onboarding')
    const payload = { id }
    let message = 'Failed to deleteRow'
    let result

    try {
      result = await wsClient.call({
        service: 'upload',
        action: 'delete',
        payload,
        withoutTokenRefresh: true,
        isAuth: true,
      })
      if (result && result.status === 'success') {
        message = ''
      }
    } catch (e: any) {
      result = getErrorResponse(message, {})
    }

    return { ...result, message }
  }

  public getUploadHistoryFilteredByTypesCrud(types: OnboardingUploadType[]) {
    const crud = CrudStore.get(
      CrudStoreItemOnboarding.UploadHistory,
      EUploadHistoryCrudKey.uploadHistoryFilteredByType
    )
    crud.setDefaultFilter({
      logic: Logic.AND,
      filters: [{ field: 'Type', operator: Operator.IN, value: types }],
    })
    crud.setSort({
      field: 'Created',
      dir: 'desc',
    })

    return crud
  }

  public invalidateCrud(crudKey: EUploadHistoryCrudKey) {
    CrudStore.get(CrudStoreItemOnboarding.UploadHistory, crudKey).removeQueries()
  }

  public invalidateAndTriggerCrudOnChange(crudKey: EUploadHistoryCrudKey) {
    CrudStore.get(CrudStoreItemOnboarding.UploadHistory, crudKey).removeQueries(true)
  }

  public triggerCrudOnChange(crudKey: EUploadHistoryCrudKey) {
    CrudStore.get(CrudStoreItemOnboarding.UploadHistory, crudKey).triggerOnChange()
  }

  public getUploadHistory = async (
    filter: IDataProviderFilter,
    { page, pageSize }: IPaging,
    sort?: IDataProviderSort | IDataProviderSort[]
  ) => {
    const wsClient = WebSocketStore.get('onboarding')
    let result

    try {
      const payload = {
        kendoConditions: filter,
        page: page + 1,
        size: pageSize,
        sort: sort ? [sort].flat() : sort,
      }
      result = await wsClient.call<{
        items: IUploadHistory[]
        total: number
      }>({
        service: 'upload',
        action: 'fetch-list',
        payload,
        withoutTokenRefresh: true,
        isAuth: true,
      })
    } catch (e: any) {
      const errorMessage = 'Failed to getUploadHistory'
      result = getErrorResponse(e.message || errorMessage, {
        items: [],
        total: 0,
      })
    }

    return result
  }
}

export const onboardingUploadHistoryApi = new OnboardingUploadHistoryApi()
